import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '200px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
}));

const LogsTableColumns = ()=>{
  const classes = useStyles();
  return [
    {
      accessorKey: 'employeeHash',
      header: 'User Hash',
      Cell: ({ cell }) => <span className={classes.ellipsisMessage}> {cell.getValue()} </span>,
      minSize: 50,
      maxSize: 100,
      size: 100,
    },
    {
      accessorKey: 'employeeName',
      header: 'User Name',
      minSize: 100,
      maxSize: 300,
      size: 150,
    },
    {
      accessorKey: 'employeeEmail',
      header: 'User Email',
      minSize: 100,
      maxSize: 200,
      size: 170,
    },
    {
      accessorKey: 'message',
      header: 'Message',
      // eslint-disable-next-line react/no-unstable-nested-components
      Cell: ({ cell }) => <span className={classes.ellipsisMessage}> {cell.getValue()} </span>,
      minSize: 100,
      maxSize: 200,
      size: 200,
    },
    {
      accessorKey: 'level',
      header: 'Level',
      minSize: 90,
      maxSize: 150,
      size: 90,
    },
    {
      accessorKey: 'type',
      header: 'Type',
      Cell: ({ cell }) => <span className={classes.ellipsisMessage}> {cell.getValue()} </span>,
      minSize: 90,
      maxSize: 100,
      size: 90,
    },
    {
      accessorKey: 'source',
      header: 'Source',
      minSize: 90,
      maxSize: 150,
      size: 90,
    },
    {
      accessorKey: 'updatedAt',
      header: 'Created At',
      minSize: 90,
      maxSize: 200,
      size: 90,
      // eslint-disable-next-line react/no-unstable-nested-components
      Cell: ({ cell }) => <span> {new Date(cell.getValue()).toLocaleDateString()} </span>,
    },
  ];
}

export default LogsTableColumns;